"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GEABFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_82)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_82`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V3.42456H-6V0ZM-6 6.84211H30V10.2667H-6V6.84211ZM-6 13.6842H30V17.1088H-6V13.6842ZM-6 20.5333H30V23.9579H-6V20.5333Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H12V10.2667H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.20356 8.0281L1.67725 6.9895V4.90529L2.98251 4.14038L4.28777 4.90529V6.47021L4.80707 5.95091L5.10181 6.16143L4.80707 6.9895L3.76146 8.0281H2.20356Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.245564 6.18941C-0.0362774 6.18941 0.133383 6.01975 0.133383 5.81047C0.133383 5.60118 -0.0362774 5.43152 -0.245564 5.43152C-0.454851 5.43152 -0.624512 5.60118 -0.624512 5.81047C-0.624512 6.01975 -0.454851 6.18941 -0.245564 6.18941Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.371989 4.70882C0.581276 4.70882 0.750936 4.53916 0.750936 4.32988C0.750936 4.12059 0.581276 3.95093 0.371989 3.95093C0.162703 3.95093 -0.00695801 4.12059 -0.00695801 4.32988C-0.00695801 4.53916 0.162703 4.70882 0.371989 4.70882Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.48075 3.62105C1.69004 3.62105 1.8597 3.45139 1.8597 3.24211C1.8597 3.03282 1.69004 2.86316 1.48075 2.86316C1.27147 2.86316 1.10181 3.03282 1.10181 3.24211C1.10181 3.45139 1.27147 3.62105 1.48075 3.62105Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.98246 3.24215C3.19175 3.24215 3.36141 3.07249 3.36141 2.8632C3.36141 2.65391 3.19175 2.48425 2.98246 2.48425C2.77318 2.48425 2.60352 2.65391 2.60352 2.8632C2.60352 3.07249 2.77318 3.24215 2.98246 3.24215Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.48417 3.62105C4.69346 3.62105 4.86312 3.45139 4.86312 3.24211C4.86312 3.03282 4.69346 2.86316 4.48417 2.86316C4.27488 2.86316 4.10522 3.03282 4.10522 3.24211C4.10522 3.45139 4.27488 3.62105 4.48417 3.62105Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.59294 4.70882C5.80222 4.70882 5.97188 4.53916 5.97188 4.32988C5.97188 4.12059 5.80222 3.95093 5.59294 3.95093C5.38365 3.95093 5.21399 4.12059 5.21399 4.32988C5.21399 4.53916 5.38365 4.70882 5.59294 4.70882Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.21049 6.18941C6.41978 6.18941 6.58944 6.01975 6.58944 5.81047C6.58944 5.60118 6.41978 5.43152 6.21049 5.43152C6.0012 5.43152 5.83154 5.60118 5.83154 5.81047C5.83154 6.01975 6.0012 6.18941 6.21049 6.18941Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_82`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GEABFlag };
